import React, { Component } from "react";
import classnames from "classnames";
import styles from "./AnnexeCategories.local.scss";
import inputStyles from "../Common/InputsLanguages/inputsLanguages.local.scss";
import _ from "i18n";
import Select from "react-select";

class AnnexeCategorySideBar extends Component {
  render() {
    const { saving, isAddingCategory, labelsForm, indicators } = this.props;

    return (
      <div
        className={classnames(
          styles.sidebar,
          isAddingCategory ? styles.display : ""
        )}
      >
        <img
          src={"/img/icons/close.svg"}
          className={styles.sidebar__close}
          onClick={() => this.props.onCancelNewCategory()}
          alt={""}
        />

        <div className={styles.sidebar__titles}>
          <h4>{_("addCategory")}</h4>
          <h5>{_("typeCategoryTitle")}</h5>
        </div>

        <div className={inputStyles.labels_form}>
          <span className={inputStyles.span_label}>
            <img src={"/img/icons/fr_flag.png"} alt={""} width={22} />
            {_("French")}
          </span>
          <div className={inputStyles.div_input}>
            <input
              type={"text"}
              placeholder={_("frTitle")}
              value={labelsForm.fr}
              onChange={e => this.props.onChangeLabelFormFr(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
          <span className={inputStyles.span_label}>
            <img src={"/img/icons/en_flag.png"} alt={""} width={22} />
            {_("English")}
          </span>
          <div className={inputStyles.div_input}>
            <input
              type={"text"}
              placeholder={_("enTitle")}
              value={labelsForm.en}
              onChange={e => this.props.onChangeLabelFormEn(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
          <span className={inputStyles.span_label}>
            <img src={"/img/icons/nl_flag.png"} alt={""} width={22} />
            {_("Dutch")}
          </span>
          <div className={inputStyles.div_input}>
            <input
              type={"text"}
              placeholder={_("nlTitle")}
              value={labelsForm.nl}
              onChange={e => this.props.onChangeLabelFormNl(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
        </div>

        <div className={styles.indicators_block}>
          <span className={styles.span_label}>{_("Associée à")}</span>
          <Select
            value={
              this.props.selectedAccount &&
              indicators.find(obj => obj.value === this.props.selectedAccount)
            }
            onChange={this.props.onChangeSelectedAccount}
            options={indicators}
            className={"indicators_new"}
            classNamePrefix="ttp-select"
            isClearable={true}
            placeholder={"Comptes et indicateurs..."}
            menuPlacement="auto"
          />
        </div>

        <div className={styles.actions_block}>
          <button
            className={styles.cancel_btn}
            onClick={() => this.props.onCancelNewCategory()}
          >
            {_("cancel")}
          </button>
          <button
            disabled={
              labelsForm.fr !== "" ||
              labelsForm.en !== "" ||
              labelsForm.nl !== ""
                ? false
                : true
            }
            className={styles.save_button}
            onClick={() => this.props.handleSaveNewCategory()}
          >
            <img
              src={"/img/icons/tail-spin.svg"}
              alt={""}
              className={saving ? styles.loading : ""}
            />
            {_("save")}
          </button>
        </div>
      </div>
    );
  }
}

export default AnnexeCategorySideBar;



// WEBPACK FOOTER //
// ./src/components/AnnexeCategories/AnnexeCategorySideBar.js